
<div class="container" >

  <app-notification *ngIf="this.errorMsg != null" [content]="this.errorMsg" timeOut="0" display="true"
                    error=true></app-notification>
  <div class="container is-widescreen">

    <app-package-container [packages]="packages" (packageSelect)="selectPackage($event)"></app-package-container>
    <div id="property-container" [ngClass]="{'is-invisible': !extraDocuments}">
      <app-products-container></app-products-container>

    </div>
    <div class="columns mt-5" >
      <div class="column mt-3 ml-3 has-border">
        <h3 class="title is-5">Berechtigtes Interesse</h3>
        <div class="select-wrapper" style="margin-bottom: 60px">
          <select id="legitimateInterest" class="dropdown is-lightblue" [(ngModel)]="legitimateInterest"
                  (change)="displayNachweis()">
            <option disabled selected value="init">Welches Berechtigtes Interesse liegt vor?</option>
            <option value="owner"> als Eigentümer</option>
            <option value="authorized" class="proof_needed">als Bevollmächtigte/ r </option>
            <option value="buyer"> als Käufer des Grundstückes</option>
            <option value="buyer"> als Erbbauberechtigte/ r</option>
            <option value="buyer"> im Rahmen einer Erbangelegenheit</option>
          </select>
        </div>
        <app-modal [active]="displayNachweisDrop" (modalClosed)="displayNachweisDrop = false">
          <app-notification *ngIf="this.errorMsg != null" [content]="this.errorMsg" timeOut="0" display="true"
                            error=true></app-notification>
          <div class="title is-5">Upload Nachweis berechtigtes Interesse:</div>
          <app-dropzone [uploadUrl]="legitimateInterestUrl" [uploadedFilesUrl]="legitimateInterestUrl" dropzoneText="Vollmacht, Kaufvertrag oder sonstigen Nachweis
hochladen" dropzoneImage="assets/images/dropzone/upload-icon.svg"></app-dropzone>
          <div class="columns">
            <div class="column">
              <div class="info__box">
                <div class="columns">
                  <div class="column is-1">
                    <img class="bookmark" alt="docestate bookmark" src="assets/images/messagebox/bookmark.jpg"/>
                  </div>
                  <div class="column">
                    <div class="info__box__head">
                      <span>Wichtige Hinweise </span>
                    </div>
                    <div class="info__box__content mt-5">
                      <div class="info__box__body">
                        Als Nicht-Eigentümer müssen Sie das berechtigte Interesse bei der Behörde mittels Nachweis
                        (Vollmacht,
                        Kaufvertrag etc.) bekunden. Ohne Nachweis kann die Behörde keine Behördenauskünfte zur Verfügung stellen.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-6 is-offset-3" style="margin-bottom: auto" >
            <button class="button is-blue"  (click)="addAuthority()">Weiter</button>
          </div>
        </app-modal>
        <h3 class="title is-5">Grundstücksdaten</h3>

        <app-property-form [property]="property" [toNextPage]="toNextPage"></app-property-form>

      </div>
    </div>
  </div>
</div>


